import {SettingRow, SettingsEnum} from 'app/_interfaces/settings.interface';
import {NUMBER_OF_LINES} from 'shared/magic';

export enum JournalSettingsKeys {
	'overview.entriesLimit' = 'overview.entriesLimit',
	'foldedAll' = 'foldedAll',
	'entryTypeExtended' = 'entryTypeExtended',
	'foldContentLinesNumber' = 'foldContentLinesNumber',
	'list.entriesPerPage' = 'list.entriesPerPage',
	'fromDate' = 'fromDate',
	'toDate' = 'toDate',
	'edit.defaultTemplate' = 'edit.defaultTemplate',
	'focusSchema' = 'focusSchema',
	'unfoldContent' = 'unfoldContent',
}
export const JournalDefaultSettings2: SettingRow[] = [
	{
		key: `${SettingsEnum.journal}.overview.entriesLimit`,
		value: 100,
		persistent: true
	},
	{
		key: `${SettingsEnum.journal}.foldedAll`,
		value: true,
		persistent: true
	},
	{
		key: `${SettingsEnum.journal}.list.entriesPerPage`,
		value: 10,
		persistent: true
	},
	{
		key: `${SettingsEnum.journal}.fromDate`,
		value: '2020-01-01T00:00:00.000Z',
		persistent: true
	},
	{
		key: `${SettingsEnum.journal}.toDate`,
		value: new Date().toISOString(),
		persistent: false
	},
	{
		key: `${SettingsEnum.journal}.edit.defaultTemplate`,
		value: '',
		persistent: true
	},
	{
		key: `${SettingsEnum.journal}.focusSchema`,
		value: false,
		persistent: true
	},
	{
		key: `${SettingsEnum.journal}.unfoldContent`,
		value: true,
		persistent: true
	},
	{
		key: `${SettingsEnum.journal}.foldContentLinesNumber`,
		value: NUMBER_OF_LINES,
		persistent: true
	},
	{
		key: `${SettingsEnum.journal}.entryTypeExtended`,
		value: [],
		persistent: true
	}
];
